
const GED_API_KEY = 'ged-api';

export class SupportService {

  serviceName: string;

  constructor(serviceName: string, public isFront: boolean = false) {
    this.serviceName = serviceName;
  }

  getKey() {
    return this.serviceName;
  }
  getLabel() {
    return this.serviceName;
  }

  getUrlpart() {
    if (this.getKey() === GED_API_KEY) {
      return '';
    } else {
      return 'proxy/' + this.getKey() + '/';
    }
  }
}


const LISTE_SERVICES_BACKEND = [GED_API_KEY, 'admin-ged-api', 'orchestra-api', 'elasticsearch-service', 'file-service', 'user-service', 'audit-service', 'admin-service', 'ocr-service'];
const LISTE_SERVICES_FRONTEND = ['front-ged', 'front-admin-ged'];
export const ACTIVE_SUPPORT_SERVICE = [...LISTE_SERVICES_BACKEND.map(service => new SupportService(service)), ...LISTE_SERVICES_FRONTEND.map(service => new SupportService(service, true))];
